
const AboutCTASection = () => {
  return (
    <section className="py-20 bg-navy">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-playfair text-4xl font-bold text-white mb-6">
          Let's Start a Conversation
        </h2>
        <p className="text-xl text-gray-200 mb-8 leading-relaxed">
          Whether you're just starting to think about your exit strategy or you're ready to move forward, we'd love to hear from you. Every conversation is confidential and no-pressure.
        </p>
        <button 
          onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
          className="btn-primary text-lg px-8 py-4"
        >
          Schedule a Confidential Call
        </button>
        <p className="text-sm text-gray-300 mt-6">
          <i className="ri-phone-line mr-2"></i>
          Speak directly with Brian, our founder
        </p>
      </div>
    </section>
  );
};

export default AboutCTASection;
